let brandIdentifier = ''

export function setBrandIdentifier(
    identifier: string | null | undefined,
): void {
    brandIdentifier = identifier ?? ''
}

export function getBrandIdentifier(): string {
    return brandIdentifier
}
